import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  z-index: 9999999999;
  pointer-events: none;
  display: block;
  width: 45rem;
  left: 80rem;
  top: 5rem;

  div {
    pointer-events: auto;
    max-width: 45rem;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 9999999999;

    .calculadora-header {
      color: #ffffff;
      background-color: #2f4050;
      padding: 1rem;
      border-radius: 5px 5px 0 0;
      font-size: 1.4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: move;

      i {
        cursor: pointer;
        font-size: 1.6rem;
      }
    }

    .calculadora-body {
      padding: 1rem;
      background-color: #f5f5f5;
      border-radius: 0 0 5px 5px;

      table {
        width: 100%;

        tr {
          height: auto !important;
        }

        input {
          max-width: 9rem;
          min-width: 7.8rem;
          height: 3rem;
        }

        th,
        td {
          padding: 0 !important;
          text-align: left !important;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Calculadora/styles.js